module.exports = __webpack_public_path__ + "img/sub-nav-links-mazda.a5dea6a8.png";